const prefix = '/admin';
const ApiRoutes = {
  LoginAs: prefix + '/login-as/{id}',
  ReadStatsLeads: prefix + '/stats/leads',
  ReadStatsExternalTherapists: prefix + '/stats/external-therapists',
  ReadRawData: prefix + '/stats/raw-data',
  GetSubscribersActivity: prefix + '/stats/subscribers-activity',

  // Subscription management
  ListSubscriptions: prefix + '/subscriptions',
  GrantSubscription: prefix + '/subscriptions/grant',
  RevokeSubscription: prefix + '/subscriptions/revoke',
  InviteToDemo: prefix + '/subscriptions/invite-demo',
  ListSubscribers: prefix + '/subscribers',
  GetUserOverview: prefix + '/users/{userId}/subscription-overview',
  UpdateSubscriptionData: prefix + '/users/{userId}/subscription-data',
  UpdateSubscriptionInstance: prefix + '/users/{userId}/subscription-instance/{instanceId}',
  AdjustBalance: prefix + '/users/{userId}/adjust-balance',
  ChargeUser: prefix + '/users/{userId}/charge',
  UpdateUserBudget: prefix + '/users/{userId}/update-budget',
  ToggleUserAds: prefix + '/users/{userId}/toggle-ads',
  ResetPaymentFailure: prefix + '/users/{userId}/reset-payment-failure',
  TerminateSubscription: prefix + '/users/{userId}/terminate-subscription',
  UpdateBillingProfile: prefix + '/users/{userId}/billing-profile',

  // User management
  UpdateUser: prefix + '/users/{userId}',
  GetUserPerformances: prefix + '/users/{userId}/performances',
  GetUserLeadStats: prefix + '/users/{userId}/lead-stats',

  // User notes (admin-internal)
  ListUserNotes: prefix + '/users/{userId}/notes',
  CreateUserNote: prefix + '/users/{userId}/notes',
  UpdateUserNote: prefix + '/notes/{noteId}',
  DeleteUserNote: prefix + '/notes/{noteId}',

  // User tags (global catalog + per-user assignments)
  ListTags: prefix + '/tags',
  ListUserTags: prefix + '/users/{userId}/tags',
  AttachUserTag: prefix + '/users/{userId}/tags',
  DetachUserTag: prefix + '/users/{userId}/tags/{tagId}',

  // Recurrent costs management
  CreateRecurrentCost: prefix + '/users/{userId}/recurrent-costs',
  UpdateRecurrentCost: prefix + '/users/{userId}/recurrent-costs/{costId}',
  DeleteRecurrentCost: prefix + '/users/{userId}/recurrent-costs/{costId}',

  // Bookings
  GetBookings: prefix + '/bookings',

  // Performances dashboard
  GetPerformances: prefix + '/performances',

  // Settings
  GetSettings: prefix + '/settings',
  UpdateSettings: prefix + '/settings',
  GetLeadNotifications: prefix + '/lead-notifications-enabled',
  UpdateLeadNotifications: prefix + '/lead-notifications-enabled',
  GetProspectSpace: prefix + '/prospect-space',
  UpdateProspectSpace: prefix + '/prospect-space',
  GetProspectCriteria: prefix + '/prospect-criteria',
  UpdateProspectCriteria: prefix + '/prospect-criteria',
  BanTherapist: prefix + '/therapists/ban',

  // Coverage stats
  GetRegions: prefix + '/regions',
  GetTherapistSearches: prefix + '/therapist-searches',

  // Prospects (prospecter page)
  ListProspects: prefix + '/prospects',
  ClaimProspect: prefix + '/prospects/{leadId}/claim',
  ListProspectTherapists: prefix + '/prospects/{leadId}/therapists',
  ListLeadNotes: prefix + '/leads/{leadId}/notes',
  CreateLeadNote: prefix + '/leads/{leadId}/notes',
  UpdateLeadNote: prefix + '/lead-notes/{noteId}',
  DeleteLeadNote: prefix + '/lead-notes/{noteId}',
  GetTherapistAvailability: prefix + '/therapists/{userId}/availability',
  CreateBooking: prefix + '/bookings',
};

export default ApiRoutes;
